const getModuleState = (state) => state.panel;

export const getPageProducts = (state) => getModuleState(state).pageProducts;
export const getProductById = (state) => getModuleState(state).product;
export const getSearchProducts = (state) => getModuleState(state).searchProducts;